import React from 'react';
import { Spinner } from 'react-bootstrap';

/** Conteneur relatif pour ancrer une liste de résultats flottante sous le champ. */
export function ReceptionSearchAnchor({ className = '', children }) {
  return <div className={`recv-search-anchor ${className}`.trim()}>{children}</div>;
}

/**
 * Panneau de résultats flottant (autocomplete) sous le champ de recherche.
 * @param {boolean} show - Afficher le panneau
 * @param {boolean} loading
 * @param {string} emptyMessage - Message si liste vide (hors chargement)
 * @param {string} listId - id pour aria-controls
 * @param {string} title - Titre optionnel en tête de liste
 */
export function ReceptionFloatingResults({
  show,
  loading = false,
  emptyMessage,
  listId,
  title,
  children,
  className = ''
}) {
  if (!show) return null;

  return (
    <div
      id={listId}
      className={`recv-floating-results ${className}`.trim()}
      role="listbox"
      aria-live="polite"
    >
      {title && <div className="recv-floating-results__title">{title}</div>}
      {loading ? (
        <div className="recv-floating-results__loading">
          <Spinner animation="border" size="sm" variant="primary" aria-hidden />
          <span>Recherche en cours…</span>
        </div>
      ) : (
        <>
          {React.Children.count(children) === 0 && emptyMessage ? (
            <p className="recv-floating-results__empty mb-0">{emptyMessage}</p>
          ) : (
            children
          )}
        </>
      )}
    </div>
  );
}

/** Ligne cliquable dans une liste flottante. */
export function ReceptionFloatingResultItem({
  primary,
  secondary,
  meta,
  actionLabel = 'Sélectionner',
  onSelect,
  selected = false
}) {
  return (
    <button
      type="button"
      role="option"
      className={`recv-floating-results__item ${selected ? 'is-selected' : ''}`}
      aria-selected={selected}
      onClick={onSelect}
    >
      <div className="recv-floating-results__item-body">
        <span className="recv-floating-results__primary">{primary}</span>
        {secondary && <span className="recv-floating-results__secondary">{secondary}</span>}
        {meta && <span className="recv-floating-results__meta">{meta}</span>}
      </div>
      {actionLabel && <span className="recv-floating-results__action">{actionLabel}</span>}
    </button>
  );
}
